import { resolveGasUrl } from "./gasUrl";

// The deployment this build talks to. Unchanged for every build that sets nothing — see `gasUrl.js`
// for why the pilot's second deployment arrives as an environment variable and not as an edit here.
// ONE named variable, not `process.env` itself. CRA replaces a bare `process.env` with a literal of
// the whole environment, so passing the object shipped every variable the deployment sets into the
// public bundle — Vercel injects a dozen of its own, including the commit message, its author and
// the repository owner and slug, and the app is handed to the client behind a viewer link. Nothing
// secret was among them (the Gemini key moved to the GAS proxy), which is luck rather than design:
// the next `REACT_APP_*` anyone adds would have gone the same way. A member access folds to just
// its string.
export const GAS_URL = resolveGasUrl({ REACT_APP_GAS_URL: process.env.REACT_APP_GAS_URL });
export const THEORETICAL_VOL = 3.1;
export const VOL_120 = 3.72;
export const VOL_150 = 4.65;
export const VOL_80 = 2.48;
export const VOL_50 = 1.55;

// Head-level tolerance (mm) — ค่ายอมรับเบี่ยงเบนหัวเจาะ (Head/Art/Tail) ±75mm
// (รวมจาก ProfileSectionView + profileSection.js เดิม → จุดเดียว)
export const HEAD_TOL_MM = 75;

// Tunnel route constants
export const CH_START_P36 = 8769.960; // CH เริ่มต้นของ P36
export const CH_EXCAV_START = 8830.488; // CH เริ่มต้นขุดเจาะ (Center Shaft IS4)
export const TOTAL_ROUTE_DISTANCE = 8874.683; // ระยะทางรวมทั้งหมด (เมตร)
// กำหนดแล้วเสร็จต่อเครื่อง (ใช้คำนวณเรทที่ต้องเร่ง + คาดเสร็จ) — null = ยังไม่มีกำหนด ⇒ ไม่เทียบกำหนด
// TBM2 ยังไม่มีกำหนดเสร็จ (ผู้ใช้ 2026-09-25)
export const PROJECT_DEADLINE = { TBM1: "2028-06-30", TBM2: null };

// Route segments ต่อเครื่อง (ระยะสะสมจากจุดเริ่มของเครื่องนั้น)
// TBM1: IS4-1 → IS3 → IS2 → IS1 · TBM2: IS4 → PS1 ไม่มีปล่องกลาง (ผู้ใช้ 2026-09-25)
export const ROUTE_SEGMENTS = {
  TBM1: [
    { id: "IS4-1", label: "IS4-1", distance: 0, color: "#6366f1" },
    { id: "IS3", label: "IS3", distance: 3065.962, color: "#8b5cf6" },
    { id: "IS2", label: "IS2", distance: 7159.586, color: "#a855f7" },
    { id: "IS1", label: "IS1", distance: 8874.683, color: "#c084fc" },
  ],
  TBM2: [
    { id: "IS4", label: "IS4", distance: 0 },
    { id: "PS1", label: "PS1", distance: 4726 },
  ],
};

// Google Drive folder สำหรับสไลด์รูปภาพหน้างานบน Dashboard (per-machine)
// ⚠ โฟลเดอร์ต้องแชร์ให้บัญชีเจ้าของ GAS เข้าถึงได้ (Anyone with the link)
export const DRIVE_PHOTOS_FOLDER = {
  TBM1: "1gLXcr1A1xuzVbDxVyCsdGA7s_T91H2XU",
  TBM2: "1gS059DzH6mjbVPKG2kLE_KwBe2ADXvr9",
};
export const drivePhotosFolder = (machine) => DRIVE_PHOTOS_FOLDER[machine] || DRIVE_PHOTOS_FOLDER.TBM1;
export const DRIVE_PHOTOS_FOLDER_ID = DRIVE_PHOTOS_FOLDER.TBM1; // default (backward compat)
